import {
	IMenuItemEntry,
	IOtherWebsitesEntry,
} from '../contentful/types/IMenuItem';

export function getActivePageProps(
	item: IMenuItemEntry | IOtherWebsitesEntry,
	currentPageId?: string,
): {} {
	const isCurrentPage =
		currentPageId && item.fields.page?.fields.id === currentPageId;

	return { 'aria-current': isCurrentPage ? 'page' : undefined };
}
